import { styled } from "@mui/material/styles";
import { Button, Container, CssBaseline, Grid, Stack, TextField, Typography } from "@mui/material";
import { red } from "@mui/material/colors";
import React, { useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useModel, useModelUpdate } from "../components/hooks/ModelProvider";
import phoneNumberOnly from "../utils/phoneNumbersOnly";
import ValidateEmail from "../utils/validEmail";
import validName from "../utils/validName";

export default function Page4() {
    const form = useRef()
    const [warning, setWarning] = useState({email:'',name:''})
    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText(red[500]),
        textTransform: "capitalize",
        fontFamily: "inherit",
        fontSize: "1.5rem",
        borderRadius: 0,
        backgroundColor: red[500],
        "&:hover": {
          backgroundColor: red[700],
        },
      }));
      const navigate = useNavigate()
      const checkValues= (e)=>{
        e.preventDefault()
        let valid =  true
        if(model?.contact?.email){
            !ValidateEmail(model?.contact?.email) && setWarning(prev=>{
                valid = false;
             return{   ...prev, email: 'Correo Invalido'}
            })
        }
        if(model?.contact?.name){
            !validName(model?.contact?.name) && setWarning(prev=>{
                valid = false;
                return {...prev, name: 'Nombre Invalido'}
            })
           
        }
        if(model?.contact?.phone){
            model?.contact?.phone.length < 14 && setWarning(prev=>{
                valid = false;
             return{   ...prev, phone: 'Numero Invalido'}
            })
            // model?.contact?.phone.length === 15 && setWarning(prev=>{
            //  return{   ...prev, phone: ''}
            // })
        }
        if(valid){
            navigate('/page5')
        }
      }
      const model = useModel();
      const setModel = useModelUpdate()
      const onChange = (e, input, funcArray=false)=>{
        let value = e.target.value
        if(funcArray){
            funcArray.map((e)=>{
             return   value = e(value);
            })
        }
        setModel({contact: { ...model.contact,[input]: value} 
        })
      }
   return( <>
   <div className='contacto'>
            <CssBaseline />
            <Container>
            <Stack sx={{marginBottom: '20px'}}minWidth="100%" direction="row" justifyContent="flex-end">
            <NavLink style={{ justifySelf: "flex-end" }} to="/page3">
            <ColorButton size="small">Regresar</ColorButton>
          </NavLink>
          </Stack>
              
                <Grid container className="contact-form-container" direction="column" justify="center" alignItems="center">
                <Typography className='page-header'component="h1">
                    Datos De Contacto
                </Typography>
                    <Grid sx={{width: '100%'}} item>
                        <form
                        form='contact-form'
                        ref={form}
                        id="contact-form"
                        style={{width: '100%', minWidth: '200px'}}
                        className='contact-form'
                        onSubmit={checkValues}
                        >
                            <Grid item>
                                <TextField
                                fullWidth
                                color="warning"
                                required
                                id="name"
                                label={warning.name ?warning.name : "Nombre"}
                                name="name"
                                className={warning.name ? "contact-form_input warning": 'contact-form_input'}
                                onChange={(e)=>{
                                    setWarning(prev =>({...prev, name: ''}))
                                    onChange(e, 'name')
                                }}
                                value={model?.contact?.name}
                                margin="normal"
                               
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                fullWidth
                                color="warning"
                                required
                                id="email"
                                label={warning.email ?warning.email : "Correo Electronico"}
                                name="email"
                                className={warning.email ? "contact-form_input warning": 'contact-form_input'}
                                onChange={(e)=>{
                                    setWarning(prev =>({...prev, email: ''}))
                                    onChange(e, 'email')
                                }}
                                value={model?.contact?.email}
                                margin="normal"
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                fullWidth
                                color="warning"
                                required
                                id="phone"
                                label={warning.phone ?warning.phone : "Telefono de contacto (10 digitos)"}
                                name="phone"
                                 className={warning.phone ? "contact-form_input warning": 'contact-form_input'}
                                onChange={(e)=>{
                                    setWarning(prev =>({...prev, phone: ''}))
                                    onChange(e, 'phone', [phoneNumberOnly])
                                }}
                                value={model?.contact?.phone}
                                margin="normal"
                                multiline
                                rowsmax="4"
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                fullWidth
                                color="warning"
                                required
                                id="address"
                                label="Dirección"
                                name="address"
                                className="contact-form_input"
                                onChange={(e)=>{
                                    onChange(e, 'address')
                                }}
                                value={model?.contact?.address}
                                margin="normal"
                                multiline
                                rowsmax="4"
                                />
                            </Grid>
                            <Grid container direction="row" spacing={2}>
                            <Grid item>
                                <TextField
                                fullWidth
                                color="warning"
                                required
                                id="Cuidad"
                                label="Cuidad"
                                name="city"
                                className="contact-form_input"
                                onChange={(e)=>{
                                    onChange(e, 'city')
                                }}
                                value={model?.contact?.city}
                                margin="normal"
                                multiline
                                rowsmax="4"
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                fullWidth
                                color="warning"
                                required
                                id="business"
                                label="Empresa"
                                name="business"
                                className="contact-form_input"
                                onChange={(e)=>{
                                    onChange(e, 'business')
                                }}
                                value={model?.contact?.business}
                                margin="normal"
                                multiline
                                rowsmax="4"
                                />
                            </Grid>
                            </Grid>
                            <Grid container direction="row" spacing={2} style={{ marginTop: 20 }}>
                            <Grid item >
                            
                            </Grid>
                            </Grid>
                           
                        </form>
                    </Grid>
                </Grid>
                <Stack sx={{marginBottom: '20px'}}minWidth="100%" direction="row" justifyContent={{xs: 'center', sm:"flex-end"}}>
                <ColorButton form='contact-form'type='submit'size="sm">Guardar y Continuar</ColorButton>
        </Stack>
        </Container>
            </div> 
            
    </>
  );    
}
